export enum ApprovalStage {
  MANAGER = 'MANAGER',
  EMS_ACCOUNT_MANAGER = 'EMS_ACCOUNT_MANAGER',
  EXTERNAL_TSMC = 'EXTERNAL_TSMC',
}
